import isSport1 from '@/utils/url/isSport1'

export default function nofollowExternal(url?: string): string | undefined {
    if (!url || isSport1(url)) {
        return undefined
    }

    return 'nofollow'
}
